import { useMemo } from 'react';

import { getPreselections } from 'Features/PickAndMix/helpers/pick-and-mix-helper';
import useDeepCompareRef from 'Hooks/useDeepCompareRef';

/**
 * A custom hook that returns pick and mix preselections based on the given parameters
 * hook uses a deep comparison to check if the values have changed
 * seperated from the component for better readability and stops needless re-renders
 * @param {Array.Object} hits
 * @param {Array.Object} tiers
 * @param {Array.Object} selectedProducts
 * @param {Array.Object} userLibrary
 * @param {Array.Object}} steamLibrary
 * @param {String} slug
 * @returns {Array.Object} preselections
 */
const usePreselections = (hits, tiers, selectedProducts, userLibrary, steamLibrary, slug) => {
  const stableHits = useDeepCompareRef(hits);
  const stableTiers = useDeepCompareRef(tiers);
  const stableUserLibrary = useDeepCompareRef(userLibrary);
  const stableSteamLibrary = useDeepCompareRef(steamLibrary);
  const stableSelectedProducts = useDeepCompareRef(selectedProducts);

  return useMemo(() =>
    getPreselections(
      stableHits, stableTiers, stableSelectedProducts, stableUserLibrary, stableSteamLibrary, slug,
    ),
  [
    slug,
    stableHits,
    stableTiers,
    stableUserLibrary,
    stableSteamLibrary,
    stableSelectedProducts,
  ]);
};

export default usePreselections;
